import { PropTypes } from 'prop-types';
import './Badge.css'
Badge.propTypes = {
    hide: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    color: PropTypes.oneOf(['red', 'blue'])
}
export default function Badge (props) {
    return <div className='t-badge-container'>
        {props.children}
        <div className={
            `${props.hide ?'t-badge-hidden':'t-badge'} ${props.color ?? 'red'}`
        }>
            {props.label}</div>
    </div>

}